// src/middlewares/pbhorder.midware.js
import config from "config";

import { userActions } from "../actions";
import { pbhRepairConstants } from "../constants";
import { entityDataGenerator } from "../helpers";

const { API, adsMsalConfig, adsDataPollTime, baseDataGridRows } = config;

export default function pbhRepairMiddleware() {
  var timer = null; // set timer to null upon transition
  // var cypress = window.Cypress;
  return ({ dispatch, getState }) =>
    (next) =>
    (action) => {
      console.info("Dispatching action:", action); // Log the action being dispatched
      const { user } = getState().authentication;

      let adsToken = localStorage.getItem(
        `ads.user.id.key${adsMsalConfig.clientID}`,
      );

      if (!adsToken || !user) {
        return next(action);
      } // return next if no token

      const pollADSData = async () => {
        let { user } = getState().authentication;

        if (user) {
          // implement polling data (await)
        }
      };

      const updatePBHRepair = async () => {
        let { user } = getState().authentication;

        if (user) {
          let { tokenExp } = user;
          let idTokenExp = tokenExp ? tokenExp.exp : null;
          // get current time in miliseconds
          let currentTime = Math.round(new Date().getTime() / 1000);

          if (tokenExp && idTokenExp >= currentTime) {
            pollADSData(); // poll ads data
          }

          clearTimeout(timer);
          timer = setTimeout(updatePBHRepair, adsDataPollTime * 60000); // set time interval
        } else {
          return userActions.msalLogout(); // forced to logout if not authenticated
        }
      };

      adsToken && user ? updatePBHRepair() : null;
      return next(action); // return next action
    };
}
